// WP4 dagelijkse schermen (docs/ux/compact-plan.md): Taken met het tabblad Sterren, Ritten als
// weergave in Agenda, het Prikbord (Notities, Berichten, Wensen), Kinderen (Leerdoelen, Groei,
// School) en de compacte Recepten en Weekmenu. Je-vorm, kort, rustig (docs/DESIGN.md §2).
export const appDailyNl = {
    stars: {
        /** Tabblad in Taken: Beloningen en Goedkeuren samen. */
        tab: 'Sterren',
        approvals: 'Goedkeuren',
        approvalsEmpty: 'Niets om goed te keuren.',
        handled: 'Afgehandeld',
        rewards: 'Beloningen',
        savingFor: 'Spaart voor {goal}',
        noGoal: 'Nog geen spaardoel',
        goalLabel: 'Spaardoel van {name}',
        adjustLabel: 'Punten aanpassen voor {name}',
        history: 'Laatste punten van {name}',
        info: 'Kinderen verdienen sterren met taken. Hier zie je per kind wat er te besteden is, waarvoor het spaart en wat er nog goedgekeurd moet worden. Een beloning toevoegen of aanpassen doe je bij Beloningen.',
    },
    agenda: {
        title: 'Agenda',
        rides: 'Ritten',
        tools: 'Meer voor de agenda',
        toolsTitle: 'Agenda',
        calendars: 'Kalenders koppelen',
        calendarsHint: 'Afspraken van Google, Outlook of iCloud hier laten zien.',
        exportHint: 'Alle afspraken als agendabestand (.ics).',
        trashHint: 'Verwijderde afspraken 30 dagen terugzetten.',
    },
    pinboard: {
        title: 'Prikbord',
        label: 'Onderdelen van het prikbord',
        notes: 'Notities',
        messages: 'Berichten',
        wishes: 'Wensen',
    },
    kids: {
        title: 'Kinderen',
        label: 'Onderdelen voor de kinderen',
        learning: 'Leerdoelen',
        growth: 'Groei',
        school: 'School',
        /** Filter op één kind (chips onder de tabbladen). */
        filter: 'Kies een kind',
        all: 'Alle kinderen',
    },
    chores: {
        /** Taken > Alle: vaste taken of klusjes (Schoonmaak en Rooster). */
        label: 'Soort taken',
        series: 'Vaste taken',
        chores: 'Klusjes',
    },
    recipes: {
        more: 'Meer laden',
        shown: '{shown} van {total}',
        pick: 'Kies een recept uit de lijst.',
        filter: 'Welke recepten',
    },
    menu: {
        past: {
            one: '{count} dag eerder deze week',
            other: '{count} dagen eerder deze week',
        },
        showPast: 'Tonen',
        hidePast: 'Verbergen',
        suggestions: 'Voorstellen',
        suggestionsCount: 'Voorstellen ({count})',
        shelfHint: 'Sleep een recept naar een dag.',
    },
};
//# sourceMappingURL=dailyApp.nl.js.map